import config from '../config';

export async function getSiteGreenPowerCertificates(backendFetch, siteId) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/green-power-certificates/' + siteId, {
        method: "GET",
        headers: {"Content-Type": "application/json"}
    })
    return await f.json()
}

export async function addGPC(backendFetch, siteId, gpc) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/green-power-certificates/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(gpc)
    })
    if (f.status !== 200) {
        console.error(f)
        throw new Error('GPC add failed')
    }
    const r = await f.json()
    const newGpc = JSON.parse(r)
    return newGpc
}

export async function updateGPC(backendFetch, siteId, gpc) {
  const f = await backendFetch(
    config.REACT_APP_HOST + "/api/v2/green-power-certificates/" + siteId + "/" + gpc.device_id,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(gpc),
    },
  );
  if (f.status !== 200) {
    console.error(f);
    throw new Error("GPC update failed");
  }
  const r = await f.json();
  const updatedGpc = JSON.parse(r);
  return updatedGpc;
}

export async function removeGPC(backendFetch, siteId, gpcId) {
  const f = await backendFetch(
    config.REACT_APP_HOST + "/api/v2/green-power-certificates/" + siteId + "/" + gpcId,
    {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    },
  );
  if (f.status !== 200 && f.status !== 204) {
    console.error(f);
    throw new Error("GPC remove failed");
  }
  return true;
}
